var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      _vm.$route.matched[1].name == 'ParsinaSupport' &&
      _vm.$route.name != 'parsinaSupportLogin'
    )?_c('the-parsina-header'):_vm._e(),(_vm.$route.matched[1].name != 'ParsinaSupport')?_c('the-header'):_vm._e(),_c('the-alerts'),_c('v-main',{class:{
      'dashboard-page':
        (_vm.$route.name === 'PACNTDashboard' && _vm.hasDashboardData) ||
        _vm.$route.name === 'PBANKDashboard' ||
        _vm.$route.name === 'PHAMYARDashboard',
    }},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('the-loading')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }